function loadCanvas(image, parent, src) {
  var originalImage = image;
  var canvas = parent.querySelector('canvas')
  var ctx = canvas.getContext('2d'),
    img = new Image();

// turn off image smoothing - this will give the pixelated effect
  ctx.mozImageSmoothingEnabled = false;
  ctx.webkitImageSmoothingEnabled = false;
  ctx.imageSmoothingEnabled = false;
  ctx.msImageSmoothingEnabled = false;

// wait until image is actually available
  img.addEventListener('load', function(){
    pixelate(canvas, img, ctx, originalImage);
  })

  img.src = src;
}

function pixelate(canvas, img, ctx, originalImage){
  canvas.width = originalImage.clientWidth;
  canvas.height = originalImage.clientHeight;

  var size = (15) * 0.01,
    // cache scaled width and height
    w = canvas.width * size,
    h = canvas.height * size;

  // draw original image to the scaled size
  ctx.drawImage(img, 0, 0, w, h);

  // then draw that scaled image thumb back to fill canvas
  // As smoothing is off the result will be pixelated
  ctx.drawImage(canvas, 0, 0, w, h, 0, 0, canvas.width, canvas.height);
}


module.exports = {
  loadCanvas: loadCanvas
};